import { mapObjectValues } from '@augment-vir/common';
import { toHtmlSafeWithTagName } from './tag-name';
export function createHostClassNamesMap(tagName, hostClassesInit) {
    if (hostClassesInit) {
        return mapObjectValues(hostClassesInit, (key) => {
            return toHtmlSafeWithTagName(tagName, String(key));
        });
    }
    else {
        return {};
    }
}
